import ordinal from 'ordinal';
import { IValidationResult } from '../../interfaces/validation.interface';

export class ImageValidator {
  constructor(
    private tags: NodeListOf<ChildNode>,
    private siteDomain: string,
  ) {}

  validate(): IValidationResult {
    return this.checkForImagesWithBase64();
  }

  checkForImagesWithBase64(): IValidationResult {
    const validationResult: IValidationResult = { errors: [], warnings: [] };

    if (this.tags) {
      const indexedTags = Array.from(this.tags).map((tag, index) => {
        return Object.assign(tag, { index });
      });

      const figures = indexedTags.filter((tag) => {
        return (
          tag.nodeName === 'FIGURE' &&
          Array.from(tag.childNodes).find((child) => child.nodeName === 'IMG')
        );
      });

      figures.forEach((figure, figureIndex) => {
        const children = figure.childNodes;
        const imageNode = Array.from(children).find(
          (child) => child.nodeName === 'IMG',
        );

        if (imageNode) {
          const source = (imageNode as HTMLElement).getAttribute('src');

          if (source) {
            const patternURL = /http([^"]+)/;
            const matchURL = source.match(patternURL);

            if (matchURL && !source.includes(this.siteDomain)) {
              const validationField = {
                message: `The <b>${ordinal(
                  figureIndex + 1,
                )} image</b> is invalid and should be replaced`,
                meta: {
                  line: figure.index + 1,
                  validator: 'image',
                },
              };

              validationResult.errors.push(validationField);
              validationResult.warnings.push(validationField);
            }
          }
        }
      });
    }

    return validationResult;
  }
}
